import { apiClient } from './client';

// Plan v0.3.0 §G-3 — typed client for the OptionGroup picklist
// registry (powering the EditableSelect component).

export interface OptionValueDto {
  id: string;
  groupKey: string;
  value: string;
  label: string | null;
  sortOrder: number;
  archived: boolean;
}

export interface CreateOptionValueBody {
  value: string;
  label?: string;
}

// data-lifecycle PR-6 — 값별 사용 건수(미사용 항목 안전 삭제 안내).
export interface OptionGroupUsageDto {
  groupKey: string;
  hasConsumer: boolean;
  values: Array<{ id: string; value: string; archived: boolean; usageCount: number }>;
}

export const optionGroupsApi = {
  async listValues(groupKey: string, includeArchived = false): Promise<OptionValueDto[]> {
    const { data } = await apiClient.get<OptionValueDto[]>(
      `/option-groups/${encodeURIComponent(groupKey)}/values`,
      includeArchived ? { params: { includeArchived: 'true' } } : undefined,
    );
    return data;
  },

  // data-lifecycle PR-6 — 값별 실제 사용 건수 + 미참조 그룹 여부.
  async usage(groupKey: string): Promise<OptionGroupUsageDto> {
    const { data } = await apiClient.get<OptionGroupUsageDto>(
      `/option-groups/${encodeURIComponent(groupKey)}/usage`,
    );
    return data;
  },

  async addValue(groupKey: string, body: CreateOptionValueBody): Promise<OptionValueDto> {
    const { data } = await apiClient.post<OptionValueDto>(
      `/option-groups/${encodeURIComponent(groupKey)}/values`,
      body,
    );
    return data;
  },

  async archiveValue(valueId: string): Promise<OptionValueDto> {
    const { data } = await apiClient.delete<OptionValueDto>(
      `/option-groups/values/${encodeURIComponent(valueId)}`,
    );
    return data;
  },

  // windows-ux-edit (2026-06, 슬라이드3) — 보관 복원.
  async restoreValue(valueId: string): Promise<OptionValueDto> {
    const { data } = await apiClient.post<OptionValueDto>(
      `/option-groups/values/${encodeURIComponent(valueId)}/restore`,
    );
    return data;
  },

  // windows-ux-edit (2026-06, 슬라이드3) — 완전 삭제(보관된 값만 서버에서 허용).
  async hardDeleteValue(valueId: string): Promise<{ id: string }> {
    const { data } = await apiClient.delete<{ id: string }>(
      `/option-groups/values/${encodeURIComponent(valueId)}/permanent`,
    );
    return data;
  },
};
